var _defs, _ellipse, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _circle2, _path2, _ellipse2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect9, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0281_sad_face",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    "data-imageid": "sad-face-82",
    imageName: "Sad Face",
    className: "illustrations_image",
    style: {
      width: 179
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_sad-face-82{clip-path:url(#clippath);}.cls-2_sad-face-82{fill:none;}.cls-2_sad-face-82,.cls-3_sad-face-82,.cls-4_sad-face-82,.cls-5_sad-face-82,.cls-6_sad-face-82,.cls-7_sad-face-82,.cls-8_sad-face-82,.cls-9_sad-face-82,.cls-10_sad-face-82,.cls-11_sad-face-82,.cls-12_sad-face-82,.cls-13_sad-face-82,.cls-14_sad-face-82,.cls-15_sad-face-82,.cls-16_sad-face-82,.cls-17_sad-face-82,.cls-18_sad-face-82,.cls-19_sad-face-82,.cls-20_sad-face-82,.cls-21_sad-face-82,.cls-22_sad-face-82,.cls-23_sad-face-82,.cls-24_sad-face-82,.cls-25_sad-face-82{stroke-width:0px;}.cls-3_sad-face-82{fill:url(#linear-gradient);}.cls-4_sad-face-82{fill:url(#linear-gradient-11-sad-face-82);}.cls-5_sad-face-82{fill:url(#linear-gradient-12-sad-face-82);}.cls-6_sad-face-82{fill:url(#linear-gradient-13-sad-face-82);}.cls-7_sad-face-82{fill:url(#linear-gradient-10-sad-face-82);}.cls-8_sad-face-82{fill:url(#linear-gradient-14-sad-face-82);}.cls-9_sad-face-82{fill:url(#linear-gradient-4-sad-face-82);}.cls-10_sad-face-82{fill:url(#linear-gradient-2-sad-face-82);}.cls-11_sad-face-82{fill:url(#linear-gradient-3-sad-face-82);}.cls-12_sad-face-82{fill:url(#linear-gradient-8-sad-face-82);}.cls-13_sad-face-82{fill:url(#linear-gradient-9-sad-face-82);}.cls-14_sad-face-82{fill:url(#linear-gradient-7-sad-face-82);}.cls-15_sad-face-82{fill:url(#linear-gradient-5-sad-face-82);}.cls-16_sad-face-82{fill:url(#linear-gradient-6-sad-face-82);}.cls-17_sad-face-82{isolation:isolate;opacity:.24;}.cls-17_sad-face-82,.cls-25_sad-face-82{fill:#68e1fd;}.cls-18_sad-face-82{fill:#f2fbff;}.cls-19_sad-face-82{fill:#26265f;}.cls-20_sad-face-82{fill:#231f20;}.cls-21_sad-face-82{fill:#d2e8ec;}.cls-22_sad-face-82{fill:#c14834;}.cls-23_sad-face-82{fill:#b3d8dc;}.cls-24_sad-face-82{fill:#ffb4a3;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-sad-face-82",
    x1: 319.31,
    y1: 529.53,
    x2: 93.7,
    y2: -108.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2-sad-face-82",
    x1: 847.56,
    y1: 3844.1,
    x2: 849.97,
    y2: 3994.46,
    gradientTransform: "translate(-471 4137.56) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3-sad-face-82",
    x1: 847.27,
    y1: 3916,
    x2: 797.9,
    y2: 3777.43,
    gradientTransform: "translate(-471 4137.56) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4-sad-face-82",
    x1: 676.75,
    y1: 3768.41,
    x2: 679.03,
    y2: 3839.07,
    gradientTransform: "translate(-471 4137.56) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5-sad-face-82",
    x1: 670.22,
    y1: 3746.4,
    x2: 684.43,
    y2: 3746.4,
    gradientTransform: "translate(-471 4137.56) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6-sad-face-82",
    x1: 644.56,
    y1: 3907.9,
    x2: 858.32,
    y2: 3639.79,
    gradientTransform: "translate(-494.09 4127.61) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath_sad-face-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2_sad-face-82",
    d: "M149.62,211.76h49.8c5.38,0,9.99,3.83,10.99,9.11l18.42,97.28h-55.56l-23.65-106.39Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7-sad-face-82",
    x1: 793.11,
    y1: 3818.48,
    x2: 742.84,
    y2: 3788.59,
    gradientTransform: "translate(-494.09 4127.61) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8-sad-face-82",
    x1: 768.13,
    y1: 3802.32,
    x2: 688.42,
    y2: 3772.43,
    gradientTransform: "translate(-494.09 4127.61) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9-sad-face-82",
    x1: 767.1,
    y1: 3894.23,
    x2: 664.29,
    y2: 3845.77,
    gradientTransform: "translate(-494.09 4127.61) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10-sad-face-82",
    x1: 749.84,
    y1: 3903.01,
    x2: 771.13,
    y2: 3927.46,
    gradientTransform: "translate(-494.09 4127.61) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11-sad-face-82",
    x1: 376.68,
    y1: 4079.05,
    x2: 570.06,
    y2: 4096.87,
    gradientTransform: "translate(-687.61 4160.71) rotate(7.67) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12-sad-face-82",
    x1: 346.8,
    y1: 4076.57,
    x2: 515,
    y2: 4092.07,
    xlinkHref: "#linear-gradient-11-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13-sad-face-82",
    x1: -687.48,
    y1: -1074.86,
    x2: -667.51,
    y2: -1074.86,
    gradientTransform: "translate(-358.05 1242.24) rotate(179.44) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14-sad-face-82",
    x1: -653.03,
    y1: -1074.86,
    x2: -633.06,
    y2: -1074.86,
    gradientTransform: "translate(-358.05 1242.24) rotate(179.44) scale(1 -1)",
    xlinkHref: "#linear-gradient-sad-face-82"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "background_sad-face-82"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17_sad-face-82 targetColor",
    d: "M440.01,180.96c-5.87-7.85-14.15-13.48-21.01-20.48-14.06-14.34-21.55-33.66-31.61-51.04-10.58-18.29-24.47-34.93-41.87-46.94-30.37-20.98-69.43-26.39-106.07-21.9-29.12,3.56-58.64,13.75-78.69,35.19-17.45,18.69-25.95,43.91-40.5,64.94-14.98,21.66-35.98,38.31-54.12,57.35-29.57,30.93-52.62,71.21-51.38,114.04.78,28.51,12.38,55.83,27.56,80.02,10.79,17.18,23.69,33.35,40.08,45.32,38.42,28.03,89.88,29.13,137.23,25.08,47.35-4.05,96.15-11.99,141.71,1.65,6.07,1.82,12.25,4.04,18.57,3.53,5.16-.43,9.99-2.65,14.5-5.2,31.21-17.71,50.68-54.16,48.08-89.92-1.4-19.33-8.7-38.34-6.71-57.64,2.53-24.55,20.87-45.67,21.47-70.38.44-18.11-6.51-49.27-17.26-63.62Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "shadow_sad-face-82",
    className: "cls-3_sad-face-82",
    cx: 275.99,
    cy: 406.94,
    rx: 148.1,
    ry: 10.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "character_sad-face-82"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 337.45,
    y: 237.84,
    width: 77.29,
    height: 167.87,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10_sad-face-82",
    x: 337.45,
    y: 237.84,
    width: 77.29,
    height: 167.87
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M339.67,215.58c3.52.29,7.23.78,10,2.96,2.77,2.17,4.09,6.61,1.82,9.31-1.93,2.33-5.46,2.4-8.5,2.27l-51.47-2.15c-4.18-.17-9.66-3.1-6.2-8,2.22-3.14,8.3-2.67,11.66-3.04,14.18-1.61,28.46-2.52,42.71-1.34Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_sad-face-82",
    d: "M293.73,218.35c-9.89-1.09-18.8,6.05-19.89,15.95-.04.39-.07.78-.09,1.18,1.14.73,2.64.17,3.87-.4l8.02-3.69c4.21-1.93,8.78-4.23,10.63-8.5"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 287.11,
    y: 230,
    width: 169.08,
    height: 9.06,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11_sad-face-82",
    x: 287.11,
    y: 230,
    width: 169.08,
    height: 9.06
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21_sad-face-82",
    x: 205.26,
    y: 395.1,
    width: 2.14,
    height: 3.43
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 199.22,
    y: 332.85,
    width: 14.22,
    height: 37.17,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9_sad-face-82",
    x: 199.22,
    y: 332.85,
    width: 14.22,
    height: 37.17
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 199.22,
    y: 387.69,
    width: 14.22,
    height: 6.95,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 201.34,
    y: 369.82,
    width: 9.95,
    height: 18.08,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25_sad-face-82 targetColor",
    x: 173.92,
    y: 391.76,
    width: 64.8,
    height: 3.45,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15_sad-face-82",
    x: 199.22,
    y: 387.69,
    width: 14.22,
    height: 6.95
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20_sad-face-82",
    x: 203.22,
    y: 396.93,
    width: 6.21,
    height: 9.24,
    rx: 1.25,
    ry: 1.25
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21_sad-face-82",
    x: 175.74,
    y: 395,
    width: 2.14,
    height: 4.67
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21_sad-face-82",
    x: 234.66,
    y: 395,
    width: 2.14,
    height: 4.67
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20_sad-face-82",
    cx: 175.14,
    cy: 402.07,
    r: 4.61
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20_sad-face-82",
    cx: 237.5,
    cy: 401.77,
    r: 4.61
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M149.62,211.76h49.81c5.37,0,9.98,3.83,10.96,9.11l20.16,107.5-57.99-4.83-22.94-111.78Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16_sad-face-82",
    d: "M149.62,211.76h49.81c5.37,0,9.98,3.83,10.96,9.11l20.16,107.5-57.99-4.83-22.94-111.78Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M212.04,334.59h-45.63c-3.95,0-7.32-2.86-7.95-6.76-16.88-105.7-16.88-107.21-16.88-108.02-.03-4.45,3.55-8.07,8-8.1,4.25-.03,7.79,3.25,8.09,7.5.51,4.21,9.22,59.17,15.62,99.28h38.77c4.45-.15,8.18,3.33,8.33,7.78s-3.33,8.18-7.78,8.33c-.19,0-.37,0-.56,0ZM157.62,219.27v.54c.06-.09.06-.27,0-.54Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1_sad-face-82"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 179.79,
    cy: 268.38,
    rx: 2.2,
    ry: 2.59,
    transform: "translate(-139.48 219.17) rotate(-47.42)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 206.14,
    cy: 268.78,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-131.2 238.12) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 182.08,
    cy: 292.37,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-156.29 228.03) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23_sad-face-82",
    cx: 209.98,
    cy: 292.37,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-147.3 248.54) rotate(-47.32)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 196.48,
    cy: 280.58,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-142.98 234.82) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 200.42,
    cy: 304.75,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-159.49 245.5) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 170.62,
    cy: 221.89,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-108.17 196.9) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 198.52,
    cy: 221.89,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-99.18 217.41) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 174.45,
    cy: 245.48,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-124.28 207.32) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 202.35,
    cy: 245.48,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-115.29 227.83) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 188.87,
    cy: 233.69,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-110.96 214.12) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 192.79,
    cy: 257.87,
    rx: 2.19,
    ry: 2.58,
    transform: "translate(-127.48 224.79) rotate(-47.32)",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M260.7,334.59h-54.02c-4.45.15-8.18-3.33-8.33-7.78s3.33-8.18,7.78-8.33c.19,0,.37,0,.56,0h54.02c4.45-.15,8.18,3.33,8.33,7.78.15,4.45-3.33,8.18-7.78,8.33-.19,0-.37,0-.56,0Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19_sad-face-82",
    d: "M291.61,190.48c.4,2.9,1.15,5.8,1.45,8.7.64,6.35-1.15,13.21-5.89,17.5-4.74,4.29-12.64,5.19-17.51,1.05-2.18-2.05-3.82-4.61-4.75-7.46-5.92-15.58-1.19-34.61,11.36-45.59,4.44-3.87,18.53-11.38,20.36-.97.72,4.08-2.9,8.51-3.98,12.33-1.32,4.69-1.68,9.6-1.04,14.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22_sad-face-82",
    d: "M247.26,391.58l-.72,9.94c1.72,1.02,3.72,1.49,5.72,1.32,3.03-.38,9.08-6.59,10.54-6.29l-.06-2.96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22_sad-face-82",
    d: "M282.64,384.48l-.72,9.94c1.72,1.02,3.72,1.49,5.72,1.33,3.03-.39,9.08-6.6,10.54-6.3l-.06-2.96"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_sad-face-82",
    d: "M257.67,283s51.31,24.16,50.86,25.43-9.93,79.2-9.93,79.2c0,0-6.81,4.59-16.43,0l-1.51-65.53-62.02-8.91s-6.1-9.15-9.49-28.82c6.71-5.33,46.71-2,48.51-1.36Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14_sad-face-82",
    d: "M257.67,283s51.31,24.16,50.86,25.43-9.93,79.2-9.93,79.2c0,0-6.81,4.59-16.43,0l-1.51-65.53-62.02-8.91s-6.1-9.15-9.49-28.82c6.71-5.33,46.71-2,48.51-1.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_sad-face-82",
    d: "M209.19,284.36s73.58,27.56,73.92,28.82c2.37,8.82-20.29,81.39-20.29,81.39,0,0-7.56,4.83-16.43-.97l7.05-65.18-36.05-10.5s-16.67-7.12-8.2-33.57Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12_sad-face-82",
    d: "M209.19,284.36s73.58,27.56,73.92,28.82c2.37,8.82-20.29,81.39-20.29,81.39,0,0-7.56,4.83-16.43-.97l7.05-65.18-36.05-10.5s-16.67-7.12-8.2-33.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M254.66,186.51c-5.71,4.08-10.63,9.81-14.99,14.71-9.14,10.28-16.51,22.01-21.81,34.7-3.13,7.55-5.33,15.56-8.52,23.25-.49,1.19-6.87,14.44-5.96,15.17,0,0,14.55,10.44,39.02,17.76,2.63.78,11.05,4.64,13.44,2.22,1.51-1.52,1.34-7.79,1.74-9.82.86-4.46,1.9-8.87,3.14-13.24,3.11-11.01,7.35-21.67,12.66-31.81,5.03-9.61,11.98-20.18,13.79-31.03,2.1-12.56-1.11-25.65-15.46-27.18-6.36-.68-12,1.64-17.05,5.25Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18_sad-face-82",
    d: "M257.58,284.51s9.17,11.46,5.29,12.5c-3.57.97-25.13-4.83-28.58-3.78s-10.22,6.48-22.65,6.19c-12.44-.3-14.22-9.41-13.13-16.38.56-4.03,2.46-7.75,5.4-10.56,0,0,41.07,16.81,53.68,12.04Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_sad-face-82",
    d: "M265.39,256.63l-13.92-10.9-3.87-23.92s-4.53,15.95-1.86,25.23c2.68,9.29,5.93,11.42,5.93,11.42l12.09,2.81c.27-1.37,1.34-3.19,1.61-4.65Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_sad-face-82",
    d: "M291.34,226.19s10.02-4.16,14.11-4.23,13.53,3.38,14.42,3.66,2.24,2.15-5.95,2.31c-8.2.16-10.7,6.66-16.85,6.05s-7.98-4.09-7.98-4.09"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M280.24,198.74l-7.73,39.56,19.44-12.09s3.87.33,4.39,9.15c0,0-20.29,20.82-28.15,22.37-35.71,7.06-6.04-58.38-6.04-58.38",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24_sad-face-82",
    d: "M328.77,190.8c-.91.88-11.45,10.93-16.95,14.01-5.5,3.08-14.5,5.43-16.9.8s-2.49-7.45-4.67-5.65c-2.08,1.95-4.01,4.04-5.8,6.26,0,0-7.43-1.93-9.72-7.34s.46-9.17.46-9.17c0,0,4.41,0,10.63-6.6,6.22-6.6,16.06-25.71,30.99-22.69,9.07,1.84,24.19,18.39,11.95,30.37Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_sad-face-82",
    d: "M340.16,182.68c-.65,5.97-4.17,11.14-11.53,12.64-3.22.66-1.08-8.65-7.05-13.22-5.97-4.57-19.24,8.59-19.88,6.93s5.58-3.87,6.02-8.64-5.61-4.14-9.17-.46c-8.65,8.94-11.96,23.98-17.67,34.98-4.08,7.88-19,22.74-27.97,12.92-1.71-1.87-2.9-4.16-4.68-5.98-2.83-2.9-6.76-4.42-10.4-6.35s-7.15-4.83-7.88-8.8c-1.13-6.28,4.89-11.21,8.5-16.48,2.61-3.82,4.09-8.31,6.6-12.2,4.83-7.53,13.31-12.16,22.02-14.28,6.95-1.69,13.8-1.47,20.87-1.93,5.54-.38,8.48-2.24,13.78-3.87,10.53-3.3,21.91-2.11,30.57,5.12,5.57,4.93,8.48,12.2,7.87,19.62Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7_sad-face-82",
    d: "M340.16,182.68c-.65,5.97-4.17,11.14-11.53,12.64-3.22.66-1.08-8.65-7.05-13.22-5.97-4.57-19.24,8.59-19.88,6.93s5.58-3.87,6.02-8.64-5.61-4.14-9.17-.46c-8.65,8.94-11.96,23.98-17.67,34.98-4.08,7.88-19,22.74-27.97,12.92-1.71-1.87-2.9-4.16-4.68-5.98-2.83-2.9-6.76-4.42-10.4-6.35s-7.15-4.83-7.88-8.8c-1.13-6.28,4.89-11.21,8.5-16.48,2.61-3.82,4.09-8.31,6.6-12.2,4.83-7.53,13.31-12.16,22.02-14.28,6.95-1.69,13.8-1.47,20.87-1.93,5.54-.38,8.48-2.24,13.78-3.87,10.53-3.3,21.91-2.11,30.57,5.12,5.57,4.93,8.48,12.2,7.87,19.62Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25_sad-face-82 targetColor",
    cx: 290.81,
    cy: 170.99,
    r: 50.67,
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4_sad-face-82",
    d: "M341.02,177.74c-3.74,27.72-29.24,47.17-56.96,43.43-27.72-3.74-47.17-29.24-43.43-56.96,3.71-27.56,28.95-46.97,56.54-43.48l.41.06c27.72,3.73,47.18,29.22,43.45,56.95,0,0,0,.01,0,.02Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5_sad-face-82",
    d: "M341.02,177.74c-3.02,22.6-20.76,40.39-43.34,43.49l-.41-.06c-27.74-3.73-47.2-29.24-43.48-56.98,3.04-22.59,20.78-40.38,43.37-43.46l.41.06c27.72,3.73,47.18,29.22,43.45,56.95,0,0,0,0,0,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M311.73,188.72l-2.67,1.74c-3.54-3.7-9.49-6.89-19.59-6.92h-.14c-7.82,0-13.03,2.73-16.5,6.15l-2.22-2.22c3.99-3.92,9.91-7.14,18.72-7.14h.16c11.55.03,18.3,3.95,22.23,8.4Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M318.87,155.95c.13,2.49-.69,4.94-2.31,6.83-1.76,1.93-4.35,2.82-7.65,2.79-3.45,0-6.08-1.02-7.83-2.96-1.5-1.73-2.27-3.97-2.15-6.25l2.59.22c-.05,1.57.48,3.1,1.5,4.3,1.25,1.35,3.23,2.06,5.9,2.08s4.49-.63,5.72-1.93c1.13-1.35,1.71-3.07,1.62-4.83l2.6-.25Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_sad-face-82",
    d: "M318.87,155.95c.13,2.49-.69,4.94-2.31,6.83-1.76,1.93-4.35,2.82-7.65,2.79-3.45,0-6.08-1.02-7.83-2.96-1.5-1.73-2.27-3.97-2.15-6.25l2.59.22c-.05,1.57.48,3.1,1.5,4.3,1.25,1.35,3.23,2.06,5.9,2.08s4.49-.63,5.72-1.93c1.13-1.35,1.71-3.07,1.62-4.83l2.6-.25Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25_sad-face-82 targetColor",
    d: "M284.42,156.29c.14,2.49-.69,4.93-2.31,6.82-1.76,1.93-4.35,2.83-7.65,2.79s-6.08-1.02-7.83-2.95c-1.5-1.73-2.27-3.98-2.15-6.26l2.59.22c-.05,1.57.48,3.11,1.5,4.31,1.25,1.35,3.24,2.05,5.9,2.08s4.49-.64,5.72-1.93c1.12-1.36,1.7-3.08,1.63-4.83l2.59-.25Z",
    style: {
      fill: "rgb(0, 77, 159)"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8_sad-face-82",
    d: "M284.42,156.29c.14,2.49-.69,4.93-2.31,6.82-1.76,1.93-4.35,2.83-7.65,2.79s-6.08-1.02-7.83-2.95c-1.5-1.73-2.27-3.98-2.15-6.26l2.59.22c-.05,1.57.48,3.11,1.5,4.31,1.25,1.35,3.24,2.05,5.9,2.08s4.49-.64,5.72-1.93c1.12-1.36,1.7-3.08,1.63-4.83l2.59-.25Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2_sad-face-82",
    x: 287.33,
    y: 230.6,
    width: 209.54,
    height: 6.64
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_sad-face-82",
    d: "M305.28,394.27c2.65,1.2,5.01,2.96,6.93,5.15.39.4.65.92.75,1.47,0,.52-.18,1.03-.51,1.43-1.5,1.93-4.36,2.01-6.76,1.85-7.74-.34-15.4-1.64-22.82-3.87-.44-.1-.84-.32-1.17-.63-.27-.35-.43-.77-.47-1.21-.35-1.9-.35-3.84,0-5.74.05-.47.24-.91.55-1.27.66-.64,1.74-.37,2.63-.13,4.55,1.24,7.65-.29,11.93-1.2,2.63-.6,6.25,2.84,8.95,4.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20_sad-face-82",
    d: "M269.96,400.92c2.65,1.2,5.02,2.95,6.93,5.15.39.4.65.91.74,1.46.01.52-.17,1.03-.51,1.43-1.49,1.93-4.35,2.01-6.76,1.85-7.74-.34-15.4-1.64-22.82-3.87-.44-.11-.84-.32-1.17-.63-.27-.36-.43-.78-.47-1.22-.36-1.89-.36-3.84,0-5.73.05-.47.24-.91.54-1.27.67-.65,1.75-.38,2.64-.13,4.55,1.24,7.64-.3,11.93-1.21,2.63-.58,6.25,2.9,8.96,4.16Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.84cd2a09e43cb25f70b25b380466c6ab.svg";
export { ForwardRef as ReactComponent };